<div class="page-title">
  <div [innerHTML]="'Agreements.Title' | translate | safe:'html'" class="title"></div>
  <div [innerHTML]="'Agreements.SubTitle' | translate | safe:'html'" class="sub-title"></div>
</div>

<mat-accordion class="document-accordion" displayMode="flat">
  <mat-expansion-panel [(expanded)]="isOpenedDisclosures" class="document-panel">
    <mat-expansion-panel-header>
      <mat-panel-title>{{ 'viewDisclosure' | translate }}</mat-panel-title>
    </mat-expansion-panel-header>
    <section *ngFor="let form of generalDisclousres" class="doc">
      <div class="description">
        {{ getFormDoc(form.formDoc.formNo).description }}
      </div>
      <div class="actions">
        <a href="/documentview?formNo={{form.formDoc.formNo}}&token={{token}}" rel="noopener noreferrer"
           target="_blank">
          <img [alt]="'view agreement'"
               [src]="navigationService.isMobile ? '/img/agreements-view-mobile.svg' : '/img/agreements-view.svg'">
        </a>
        <button (click)="downloadForm(form.formDoc.formNo, form.formDoc.formName)" class="icon-button">
          <img [alt]="'download agreement'"
               [src]="navigationService.isMobile ? '/img/agreements-download-mobile.svg' : '/img/agreements-download.svg'">
        </button>
      </div>
    </section>
  </mat-expansion-panel>

  <mat-expansion-panel [(expanded)]="isOpenedAgreements" class="document-panel">
    <mat-expansion-panel-header>
      <mat-panel-title>{{ 'viewAgreements' | translate }}</mat-panel-title>
    </mat-expansion-panel-header>
    <section *ngFor="let form of generalAgreements" class="doc">
      <div class="description">
        {{ getFormDoc(form.formDoc.formNo).description }}
      </div>
      <div class="actions">
        <a href="/documentview?formNo={{form.formDoc.formNo}}&token={{token}}" rel="noopener noreferrer"
           target="_blank">
          <img [alt]="'view agreement'"
               [src]="navigationService.isMobile ? '/img/agreements-view-mobile.svg' : '/img/agreements-view.svg'">
        </a>
        <button (click)="downloadForm(form.formDoc.formNo, form.formDoc.formName)" class="icon-button">
          <img [alt]="'download agreement'"
               [src]="navigationService.isMobile ? '/img/agreements-download-mobile.svg' : '/img/agreements-download.svg'">
        </button>
      </div>
    </section>
  </mat-expansion-panel>
</mat-accordion>

<br><br>

<form [formGroup]="agreementFrom" class="agreement-form">
  <div *ngIf="getMarginType() === 'Margin'" class="checkbox-group">
    <mat-checkbox (change)="acceptGeneralAgreements()"
                  [disableRipple]="true"
                  [ngClass]="{'invalid': isRequiredField('margin')}"
                  class="agreement-checkbox" formControlName="margin" name="margin">
      <div class="agreement-checkbox agreement-info">
        <span [innerHTML]="'margin' | translate | translateCut:0"></span>

        <app-info-hint>
          <ng-template>
            <span [innerHTML]="'marginDescription' | translate"></span>
          </ng-template>
        </app-info-hint>
      </div>
    </mat-checkbox>

    <div *ngIf="isRequiredField('margin')"
         [innerHTML]="'Agreements.Error.MarginRequired' | translate"
         class="error">
    </div>

    <div *ngIf="descriptionStates['margin']" class="agreement-description">
      <button (click)="switchDescriptionState($event, 'margin')" class="close"></button>
      <div [innerHTML]="'marginDescription' | translate | safe:'html'"></div>
    </div>
  </div>

  <div class="checkbox-group">
    <mat-checkbox [disableRipple]="true"
                  [ngClass]="{'invalid': isRequiredField('syep')}"
                  class="agreement-checkbox"
                  formControlName="syep" name="syep">
      <div class="agreement-checkbox agreement-info">
        <span [innerHTML]="'stockYieldProgram' | translate | translateCut:0"></span>

        <app-info-hint>
          <ng-template>
            <span [innerHTML]="'stockYieldProgramDescription' | translate"></span>
          </ng-template>
        </app-info-hint>
      </div>
    </mat-checkbox>

    <div *ngIf="isRequiredField('syep')"
         [innerHTML]="'Agreements.Error.SyepRequired' | translate"
         class="error">
    </div>

    <div *ngIf="descriptionStates['syep']" class="agreement-description">
      <button (click)="switchDescriptionState($event, 'syep')" class="close"></button>
      <div [innerHTML]="'stockYieldProgramDescription' | translate | safe:'html'"></div>
    </div>
  </div>

  <div class="checkbox-group">
    <mat-checkbox (change)="acceptGeneralAgreements()"
                  [ngClass]="{'invalid': isRequiredField('isAgree')}"
                  class="agreement-checkbox"
                  formControlName="isAgree" name="isagree">
      <div class="agreement-checkbox agreement-info">
        <span [innerHTML]="'acknowledgeDisclosureAndAgreements' | translate"></span>
      </div>
    </mat-checkbox>

    <div *ngIf="isRequiredField('isAgree')"
         [innerHTML]="'Agreements.Error.Required' | translate"
         class="error">
    </div>
  </div>

  <div class="checkbox-group">
    <mat-checkbox (change)="acceptAdditionalGeneralAgreements()"
                  [ngClass]="{'invalid': isRequiredField('isAdditionalAgree')}"
                  class="agreement-checkbox"
                  formControlName="isAdditionalAgree"
                  name="isAdditionalAgree">
      <div class="agreement-checkbox agreement-info">
        <span [innerHTML]="'additionalAgreeDisclosureAndAgreements' | translate"></span>
      </div>
    </mat-checkbox>

    <div *ngIf="isRequiredField('isAdditionalAgree')"
         [innerHTML]="'Agreements.Error.RequiredAdditionalAgree' | translate"
         class="error">
    </div>
  </div>
</form>
